"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@angular/material");
const app_service_1 = require("../../commons/app.service");
const _4d_mapper_1 = require("4d-mapper");
const entity_helper_service_1 = require("../../service/entity-helper.service");
const map_service_1 = require("../../commons/map.service");
const Cesium = window.Cesium;
class AnnotationReportComponent {
    constructor(dialogRef, data, service, fourD, entityHelper, mapService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.service = service;
        this.fourD = fourD;
        this.entityHelper = entityHelper;
        this.mapService = mapService;
        this.noOfColumns = 2;
        this.gridColumns = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        this.viewer = null;
        this.helper = null;
        this.entities = {};
    }
    ngOnInit() {
        console.log(this.data);
        this.viewer = this.mapService.viewer;
        this.getScreenShotByAnnotation();
    }
    ngOnDestroy() {
    }
    onCNX() {
        this.dialogRef.close();
    }
    flyTo(annotation) {
        console.log("flyTo()", annotation, annotation.id);
        if (annotation) {
            let find = this.entities[annotation.id];
            console.log("flyTo() entity", find, this.entities);
            if (find) {
                this.flyToEntity(find);
            }
        }
    }
    flyToEntity(entity) {
        console.log("flyToEntity()", entity);
        if (entity) {
            this.viewer.zoomTo(entity);
        }
    }
    getScreenShotByAnnotation() {
        let entities = this.viewer.entities.values;
        console.log('All models', this.data.model, entities);
        this.data.model.forEach(a => {
            if (a['shapes'] && a['shapes'].length) {
                a['shapes'].forEach(shape => {
                });
            }
            let entities = this.entityHelper.getEntitiesByAnnotationId(a.id);
            if (entities) {
                console.log("entities for [" + a.id + "]", entities);
                entities.forEach(e => {
                    console.log("entity object", e, e.obj);
                    if (e.obj) {
                        // let config = a['entity_config']; // this.entityHelper.getEntityConfig ( a['annotationMode'], {}, a );
                        this.entities[a.id] = e.obj;
                        // this.flyToEntity ( this.entities[a.id] );
                        this.flyToEntity(e.obj);
                        console.log('### found', this.entities[a.id]);
                    }
                });
            }
            // console.log ( '!!!', a.id, entities );
            // a.screenshotName = null;
            this.service.V.api('/api/Annotation/' + a.id + '.files').subscribe(files => {
                for (let idx = 0; idx < files.length; idx++) {
                    // look for PNG file(s), assume the first one os a screenshot (this needs to be better handled in the future)
                    if (files[idx].mimeType == 'image/png') {
                        a.screenshotName = files[idx].name;
                    }
                    // thumbs.flyTo
                }
            }, error1 => {
                console.error('error while geting files by annotation id ', error1);
            });
        });
        this.data.model.forEach(a => {
            this.flyTo(a);
        });
    }
    getDateTime() {
        return new Date();
    }
    getRowHeight() {
        return (this.noOfColumns) + ':' + (this.noOfColumns / 1.5);
        // return (this.noOfColumns / 2) + ':' +  (this.noOfColumns);
    }
    print() {
        let printContents, popupWin;
        printContents = document.getElementById('print-section').innerHTML;
        const stylesHtml = this.getTagsHtml('style');
        const linksHtml = this.getTagsHtml('link');
        popupWin = window.open('', '_blank', '');
        popupWin.document.open();
        popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          ${linksHtml}
          ${stylesHtml}
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`);
        popupWin.document.close();
    }
    getTagsHtml(tagName) {
        const htmlStr = [];
        const elements = document.getElementsByTagName(tagName);
        for (let idx = 0; idx < elements.length; idx++) {
            htmlStr.push(elements[idx].outerHTML);
        }
        return htmlStr.join('\r\n');
    }
}
exports.AnnotationReportComponent = AnnotationReportComponent;
